export const STOP_PLAYBACK_EVENT = 'madameai:stop-playback';

export function requestPlaybackStop(reason = 'unknown') {
  if (typeof window === 'undefined' || typeof window.dispatchEvent !== 'function') {
    return;
  }

  window.dispatchEvent(new CustomEvent(STOP_PLAYBACK_EVENT, {
    detail: { reason }
  }));
}
